// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* Sidemenu SVG icon hover effects for InstantCatalog */
.sidemenu-icon-button {
    transition: all 0.2s ease;
}

.sidemenu-icon-button .svg-container {
    position: relative;
}

.sidemenu-icon-button .svg-icon {
    transition: opacity 0.2s ease;
}

.sidemenu-icon-button .svg-default {
    opacity: 1;
}

.sidemenu-icon-button .svg-hover {
    opacity: 0;
}

.sidemenu-icon-button:hover .svg-default,
.sidemenu-icon-button:focus .svg-default,
.sidemenu-icon-button:active .svg-default {
    opacity: 0;
}

.sidemenu-icon-button:hover .svg-hover,
.sidemenu-icon-button:focus .svg-hover,
.sidemenu-icon-button:active .svg-hover {
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/v2/layout/common/InstantCatalog.css"],"names":[],"mappings":";;AAEA,uDAAuD;AACvD;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;IAGI,UAAU;AACd","sourcesContent":["\n\n/* Sidemenu SVG icon hover effects for InstantCatalog */\n.sidemenu-icon-button {\n    transition: all 0.2s ease;\n}\n\n.sidemenu-icon-button .svg-container {\n    position: relative;\n}\n\n.sidemenu-icon-button .svg-icon {\n    transition: opacity 0.2s ease;\n}\n\n.sidemenu-icon-button .svg-default {\n    opacity: 1;\n}\n\n.sidemenu-icon-button .svg-hover {\n    opacity: 0;\n}\n\n.sidemenu-icon-button:hover .svg-default,\n.sidemenu-icon-button:focus .svg-default,\n.sidemenu-icon-button:active .svg-default {\n    opacity: 0;\n}\n\n.sidemenu-icon-button:hover .svg-hover,\n.sidemenu-icon-button:focus .svg-hover,\n.sidemenu-icon-button:active .svg-hover {\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
